<template>
  <div>
    <button
      ref="open_button"
      tabindex="0"
      role="button"
      class="btn m-1"
      @click="toggle_menu"
    >
      <i class="fa-solid fa-ellipsis-vertical"></i>
    </button>
    <teleport to="#app">
      <ul
        v-if="open"
        ref="dropdown_content"
        tabindex="-1"
        class="menu bg-base-100 rounded-box fixed z-10 max-h-screen w-52 overflow-auto p-2 shadow-sm"
      >
        <li>
          <InjectActionDropdown :process="process" />
        </li>
        <li>
          <ConfirmKillProcess :id="process?.id" :process_id="process?.pid" />
        </li>
        <li>
          <ConfirmSuspendProcess :id="process?.id" :process_id="process?.pid" />
        </li>
        <li>
          <ProcessDetailModal :process="process" />
        </li>
      </ul>
    </teleport>
  </div>
</template>

<script setup lang="ts">
import { onClickOutside } from "@vueuse/core";
import { nextTick, onMounted, ref } from "vue";
import type { process as ProcessType } from ".";
import ConfirmKillProcess from "./ConfirmKillProcess.vue";
import ConfirmSuspendProcess from "./ConfirmSuspendProcess.vue";
import ProcessDetailModal from "./ProcessDetailModal.vue";
import InjectActionDropdown from "./InjectActionDropdown.vue";

const open = ref(false);
const open_button = ref<HTMLButtonElement | null>();
const dropdown_content = ref<HTMLUListElement | null>();

defineProps<{
  process?: ProcessType;
}>();

const toggle_menu = () => {
  if (open.value) {
    open.value = false;
    return;
  }
  open_menu();
};

const open_menu = async () => {
  open.value = true;
  await nextTick();
  if (!open_button.value || !dropdown_content.value) return;
  const buttonRect = open_button.value.getBoundingClientRect();
  const contentRect = dropdown_content.value.getBoundingClientRect();
  if (!buttonRect || !contentRect) return;
  const menuHeight = contentRect.height;
  const posUnderButton = buttonRect.top + 8 + open_button.value.offsetHeight;
  const isOverflow = posUnderButton + menuHeight > document.body.offsetHeight;
  dropdown_content.value.style.top = isOverflow
    ? `${buttonRect.top - 8 - menuHeight}px`
    : `${posUnderButton}px`;
  dropdown_content.value.style.left = `${buttonRect.left - 156}px`;
};

onClickOutside(dropdown_content, () => {
  open.value = false;
});

onMounted(() => {
  document.addEventListener("wheel", () => {
    open.value = false;
  });
  return document.removeEventListener("wheel", () => {});
});
</script>